import styled from 'styled-components';

// Warranty Exclusivity Styles
export const WarrantyExclusivitySection = styled.div`
  background-color: #feffb2;
  border-radius: 8px;
  padding: 8px;
`;

export const WarrantyExclusivityTitle = styled.h3`
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 500;
  color: #171c24;
  margin-bottom: 10px;
`;

export const WarrantyExclusivityItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const WarrantyExclusivityText = styled.span`
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 500;
  color: #171c24;
  margin-left: 12px;
`;

// Warranty Options Styles
export const WarrantyOptionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 20px;
  width: 100%;
  margin-top: 1.25rem;
`;

export const WarrantyCenteredOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const WarrantyOptionsRow = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.columns === 2 ? '1fr 1fr' : '1fr 1fr 1fr')};
  width: 100%;
  justify-items: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const WarrantyOptionCard = styled.div`
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: #f3f3f3;
  border-radius: 0px 0px 4px 4px;
  background-color: ${props => (props.selected ? '#EAFFEE' : '#ffffff')};
  box-shadow: ${props =>
    props.selected ? '0px 0px 4px 3px rgba(0, 168, 31, 0.769)' : '2px 4px 12px 0px #0000001F'};
  border-color: ${props => (props.selected ? '#B2E5BC' : 'transparent')};
  border-width: 1px;
  border-style: solid;

  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 20px;
  max-width: 343px;
`;

export const WarrantyOptionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => (props.selected ? '#B2E5BC' : '#f3f3f3')};
  padding: 8px 12px;
`;

export const WarrantyOptionRadio = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #757778;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    box-shadow: 0px 0px 10.8px 0px ${props => (props.selected ? '#00A81F' : 'transparent')};
    backdrop-filter: blur(0.9600000381469727px);
    background-color: ${props => (props.selected ? '#00A81F' : 'transparent')};
  }
`;

export const WarrantyOptionTitle = styled.h4`
  font-family: Rubik;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.color ?? '#000000'};
`;

export const WarrantyCoverageList = styled.div`
  margin-bottom: 6px;
  padding: 24px 10px 10px 10px;
`;

export const WarrantyCoverageItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 3px;
  font-size: 11px;
  align-self: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const WarrantyCoverageItemMinor = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3px;
  font-size: 11px;
  padding: 0px 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const WarrantyCoverageIcon = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 12px;
    height: 12px;
    fill: #00a81f;
  }
`;

export const WarrantyCoverageText = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  text-align: left;
`;

export const WarrantyCoverageTextHighlight = styled.span`
  font-weight: 500;
`;

export const WarrantyCoveragePeriod = styled.span`
  font-family: Rubik;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  margin-top: 4px;
`;

export const WarrantyCoveragePeriodHighlight = styled.span`
  font-weight: 500;
`;

export const WarrantyOptionPrice = styled.div`
  font-family: Rubik;
  font-size: 1.5rem;
  font-weight: 700;
  color: #000000;
  text-align: center;
  margin-top: 8px;
`;

export const WarrantyPlusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1px 0;

  &::after {
    content: '+';
    font-size: 12px;
    font-weight: bold;
    color: #666666;
  }
`;

export const WarrantyCoverageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const PlusDivider = styled.span`
  font-family: 'Balboa Condensed', sans-serif;
  font-size: 33px;
  font-weight: 500;
  color: #000000;
  line-height: 43px;
  margin-top: 2px;
`;
